/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { EntityDxpUserMeAgencyTypes, EntityDxpUserMeTenantTypes } from '../../Services/console';

/**
 * Get flat list of all tenants in the user's data.
 */
export const getFlatTenantList = (tenantList: Array<EntityDxpUserMeAgencyTypes>): Array<EntityDxpUserMeTenantTypes> => {
  const allTenants: Array<EntityDxpUserMeTenantTypes> = [];

  if (tenantList) {
    tenantList.forEach((agency) => {
      allTenants.push(agency); // Push the agency
      allTenants.push(...agency.organisations); // Push the child orgs
    });
  }

  return allTenants;
};
